import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = ({ title, description, keywords }) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta name='description' content={description} />
			<meta name='keyword' content={keywords} />
		</Helmet>
	)
}

Meta.defaultProps = {
	title: 'Welcome To Saidham',
	description: 'Community center for devotees',
	keywords: 'Sai temple, Baba temple, Sai Mandhir',
}

export default Meta
